import React, { useEffect, useState } from 'react';
import { useIsMobile, useIsSmallTablet } from 'hooks/use-size-class';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import DownArrowIcon from 'components/icon/down-arrow-icon';

export default function JoinExpUSHeroEs({ downArrowRef }: { downArrowRef: React.RefObject<HTMLDivElement> }) {
  const [activeIndices, setActiveIndices] = useState<number[]>([]);
  const isMobile = useIsMobile();
  const isTablet = useIsSmallTablet();
  const [isPageLoaded, setIsPageLoaded] = useState(false);

  const onArrowClick = () => {
    if (downArrowRef.current) {
      downArrowRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setIsPageLoaded(true);
    }, 500);
  }, []);

  useEffect(() => {
    let intervalId: number | undefined;
    if (isMobile || isTablet) {
      intervalId = window.setInterval(() => {
        const randomIndex = Math.floor(Math.random() * 8);
        setActiveIndices([randomIndex]);
      }, 2000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isMobile, isTablet]);

  return (
    <div className={styles.component} data-testid="HeroES">
      <div className={styles['video-container']}>
        <video autoPlay muted loop>
          <source src="/next/assets/videos/join-expus/join-expus-hero-video.mp4" type="video/mp4" />
        </video>
      </div>
      <div className={styles['content-container']}>
        <h1 className={isPageLoaded ? styles.visible : ''}>
          <span className={buildClassName(styles.J, activeIndices.includes(0) ? styles.activeLetter : '')}>Ú</span>
          <span className={activeIndices.includes(1) ? styles.activeLetter : ''}>N</span>
          <span className={activeIndices.includes(2) ? styles.activeLetter : ''}>E</span>
          <span className={activeIndices.includes(3) ? styles.activeLetter : ''}>T</span>
          <span className={activeIndices.includes(4) ? styles.activeLetter : ''}>E</span>
          <span> </span>
          <span className={buildClassName(styles.U, activeIndices.includes(5) ? styles.activeLetter : '')}>H</span>
          <span className={activeIndices.includes(6) ? styles.activeLetter : ''}>O</span>
          <span className={activeIndices.includes(7) ? styles.activeLetter : ''}>Y</span>
        </h1>
        <a className={styles['down-arrow-container']} onClick={onArrowClick} data-testid="DownArrowES">
          <DownArrowIcon className={styles['down-arrow']}/>
        </a>
        <div className={styles['hero-quote-container']}>
          <p>a El Lugar Donde <span className={styles.bold}>Crecen</span> </p>
          <p>los <span className={styles.bold}>Profesionales</span></p>
        </div>
      </div>
    </div>
  );
}
